import { COMMUNITY_URL, DOCUMENTATION_URL } from '#constants';

import solutionsImage from './assets/black.webp';

export const NAVBAR_LINKS = {
  // product: {
  //   title: 'menu.product.title',
  //   items: [
  //     {
  //       path: '/features',
  //       label: 'menu.product.items.features',
  //     },
  //     {
  //       path: '/templates',
  //       label: 'menu.product.items.templates',
  //     },
  //     {
  //       path: '/automation',
  //       label: 'menu.product.items.automation',
  //     },
  //   ],
  // },
  resources: {
    title: 'menu.resources.title',
    items: [
      {
        path: COMMUNITY_URL,
        label: 'menu.resources.items.community',
        type: 'image',
        src: solutionsImage.src,
      },
      {
        path: DOCUMENTATION_URL,
        label: 'menu.resources.items.help-center',
      },
      {
        path: 'https://docs.zealy.io/',
        label: 'menu.resources.items.api-docs',
      },
      {
        path: 'https://blog.zealy.io/',
        label: 'menu.resources.items.blog',
      },
    ],
  },
  products: {
    title: 'menu.products.title',
    forceColumnLayout: true,
    items: [
      {
        path: '/about',
        label: 'menu.products.items.about',
      },
      {
        path: '/enterprise',
        label: 'menu.products.items.enterprise',
      },
      {
        path: '/trading-competitions',
        label: 'menu.products.items.trading-competitions',
      },
      {
        path: '/kol-network',
        label: 'menu.products.items.kol-network',
      },
      {
        path: '/prediction-market',
        label: 'menu.products.items.prediction-market',
        isComingSoon: true,
      },
    ],
  },
} as const;

export type NavbarLinkMapper = typeof NAVBAR_LINKS;
